<template>
  <div>
    <router-view/>
    <mt-tabbar class="bar_tab" v-model="selected">
      <mt-tab-item id="group">
        <img slot="icon" src="../assets/btn_group_gray.png" v-show="tab1_normal">
        <img slot="icon" src="../assets/btn_group_red.png" v-show="tab1_selected">
      </mt-tab-item>
      <mt-tab-item id="me">
        <img slot="icon" src="../assets/btn_me_gray.png" v-show="tab2_normal">
        <img slot="icon" src="../assets/btn_me_red.png" v-show="tab2_selected">
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Main',
  data: function () {
    return {
      selected: 'group',
      tab1_normal: false,
      tab2_normal: true,
      tab1_selected: true,
      tab2_selected: false
    }
  },
  created() {
    
  },
  watch: {
    selected: function(newVal) {
      if (newVal === 'group') {
        this.$router.push({ path: `/user/${this.$route.params.userId}/joined_groups` })
        this.tab1_normal = false
        this.tab2_normal = true
        this.tab1_selected = true
        this.tab2_selected = false
      } else {
        this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
        this.tab1_normal = true
        this.tab2_normal = false
        this.tab1_selected = false
        this.tab2_selected = true
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .main {
    padding: 0 20px;
    max-width: 400px;
    margin: 0 auto;
    .mint-button {
      margin-bottom: 10px;
    }
  }
  .bar_tab {
    position: fixed !important;
  }
</style>
  